import React, { FC } from 'react'
import StarRating from 'components/star-rating'
import ProgressBar from 'components/progress-bar'

import theme from 'styles/theme'
import { Center, Section } from '../styled'

import {
	SectionTitle,
	SectionSubTitle,
	StarsContainerMobile,
	StarsContainerMedium,
	StarsContainerDesktop
} from './styled'

type Props = {
	aggregateRating: number
	numReviews: number
}

const AggregateReviewSection: FC<Props> = ({ aggregateRating, numReviews }) => {
	// Hard coded scores are real numbers between 0 and 5
	const reviewCategories = [
		{label: 'ease', score: 5},
		{label: 'value', score: 4.7},
		{label: 'utility', score: 4.8},
		{label: 'speed', score: 4.6}
	]

	const scoreToPercent = (score: number) => (score / 5) * 100

  return (
    <Section>
    	<Center>
    	  <SectionTitle>
    	    {aggregateRating} average rating
    	  </SectionTitle>
      	<StarsContainerMobile>
	      	<StarRating
	      		rating={aggregateRating}
	      		name="aggregate-rating-mobile"
	      		fillColor={theme.color.accent.secondary}
	      		starDimension="4rem"
	      	/>
	      </StarsContainerMobile>
      	<StarsContainerMedium>
	      	<StarRating
	      		rating={aggregateRating}
	      		name="aggregate-rating-desktop"
	      		fillColor={theme.color.accent.secondary}
	      		starDimension="6rem"
	      	/>
	      </StarsContainerMedium>
      	<StarsContainerDesktop>
	      	<StarRating
	      		rating={aggregateRating}
	      		name="aggregate-rating-desktop"
	      		fillColor={theme.color.accent.secondary}
	      		starDimension="10rem"
	      	/>
	      </StarsContainerDesktop>
	      <SectionSubTitle>
	      	Based on {numReviews} reviews
	      </SectionSubTitle>
	      {reviewCategories.map(category => (
					<ProgressBar
						key={category.label}
						bgColor={theme.color.accent.secondary}
						label={category.label}
						percentCompleted={scoreToPercent(category.score)}
						score={category.score}
					/>
	      ))}
      </Center>
    </Section>
  )
}

export default AggregateReviewSection
